import axios from "axios";
import { handleResponse, handleError } from "./apiUtils";

export function getTemplate(templateId, apiConfig) {
	const url = apiConfig.apiUrl + "/wprk/v1/templates/" + templateId;
	const headers = {
		"X-WP-NONCE": apiConfig.nonce,
		"Content-Type": "application/json",
	};
	return axios.get(url, { headers, withCredentials: true }).then(handleResponse).catch(handleError);
}

export function createFormSubmission(submissionBody, apiConfig) {
	const url = apiConfig.apiUrl + "/wprk/v1/submissions";
	const headers = {
		"X-WP-NONCE": apiConfig.nonce,
		"Content-Type": "application/json",
	};
	const data = JSON.stringify({ form: submissionBody });
	return axios(url, {
		method: "POST",
		headers,
		data,
		withCredentials: true,
	})
		.then(handleResponse)
		.catch(handleError);
}
